import * as types from "./actionTypes"
import {
    capitalizeFirstLetter,
    getPlanStatusArray,
    sortAlphabetically,
} from "../../constants/utils"

const initialState = {
    allData: {},
    name: "",
    description: "",
    status: [],
    allPlans: [],

    specifications: [],
    selectedCar: "",
    addedChips: [],
    selectedSpecification: "",
    data: {
        positions: {},
    },
    addPlan: {
        status: true,
        from: "",
    },
    editPlan: {
        status: false,
        from: "",
        planName: "",
    },
    defaultPlan: {},
    deletePlan: {},
}
export default function carsReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_ALL_DATA_SUCCESS:
            return {
                ...state,
                allData: action.payload,
            }
        case types.CLEAR_PLANS:
            return {
                ...state,
                allPlans: [],
            }
        case types.FETCH_ALL_PLANS_SUCCESS:
            return {
                ...state,
                allPlans: sortAlphabetically(action.payload, "planName"),
            }
        case types.FETCH_CAR_SPECIFICATION:
            return {
                ...state,
                selectedCar: action.payload,
                specifications: Object.keys(
                    state.allData[capitalizeFirstLetter(action.payload)].types
                ),
            }
        case types.FETCH_CAR_SPECIFICATION_SUCCESS:
            return {
                ...state,
                specifications: action.payload,
            }
        case types.FETCH_ALL_POSITION_DATA: {
            let selectedSpecification =
                action.payload.status && action.payload.status !== "undefined"
                    ? action.payload.status
                    : ""
            let selectedCar = action.payload.car
            let positionData = selectedSpecification
                ? state.allData[capitalizeFirstLetter(selectedCar)].types[
                      selectedSpecification
                  ]
                : state.allData[capitalizeFirstLetter(selectedCar)]
            return {
                ...state,
                selectedSpecification: selectedSpecification,
                selectedCar: selectedCar,
                data: positionData,
            }
        }
        case types.FETCH_ALL_POSITION_DATA_SUCCESS:
            return {
                ...state,
                data: action.payload,
            }
        case types.CLEAR_POSITION_DATA:
            return {
                ...state,
                selectedCar: "",
                selectedSpecification: "",
                specifications: [],
                data: { positions: null },
            }
        case types.SET_DATA_BY_FIRST_CHAR:
            return {
                ...state,
                selectedSpecification: action.payload.specification,
                selectedCar: action.payload.carType,
                data: {
                    code: action.payload.code,
                    positions: action.payload.positions,
                },
            }
        case types.ADD_CHIPS:
            return {
                ...state,
                addedChips: [...state.addedChips, action.payload],
            }
        case types.DELETE_CHIPS: {
            return {
                ...state,
                addedChips:
                    action.payload >= 0 &&
                    action.payload < state.addedChips.length
                        ? state.addedChips.filter(
                              (_, i) => action.payload !== i
                          )
                        : state.addedChips,
            }
        }
        case types.SET_PLAN_DETAILS: {
            return {
                ...state,
                [action.payload.name]: action.payload.value,
            }
        }
        case types.ADD_NEW_PLAN: {
            return {
                ...state,
                addPlan: {
                    status: true,
                    from: action.payload,
                },
                editPlan: {
                    status: false,
                    from: "",
                    planName: "",
                },
            }
        }
        case types.FETCH_PLAN_COPY: {
            return {
                ...state,
                addPlan: {
                    status: true,
                    from: "",
                },
            }
        }
        case types.ADD_NEW_PLAN_CANCEL: {
            return {
                ...state,
                addPlan: {
                    status: false,
                    from: "",
                },
            }
        }
        case types.FETCH_PLAN_EDIT: {
            return {
                ...state,
                editPlan: {
                    status: action.payload.status,
                    from: action.payload.from,
                    planName: action.payload.planName,
                },
                addPlan: {
                    status: false,
                    from: "",
                },
            }
        }
        case types.FETCH_PLAN_EDIT_SUCCESS: {
            return {
                ...state,
                name: action.payload.planName,
                description: action.payload.planDescription,
                status: getPlanStatusArray(action.payload.leStatus),
                addedChips: [
                    ...(action.payload.carTypes &&
                    action.payload.carTypes.length
                        ? action.payload.carTypes
                        : []),
                ],
            }
        }
        case types.UPDATE_PLAN_SUCCESS: {
            return {
                ...state,
                name: "",
                description: "",
                status: [],
                addedChips: [],
                addPlan: {
                    status: false,
                    from: "",
                },
                editPlan: {
                    status: false,
                    from: "",
                    planName: "",
                },
            }
        }
        case types.CREATE_NEW_PLAN_SUCCESS: {
            return {
                ...state,
                name: "",
                description: "",
                status: [],
                addedChips: [],
                addPlan: {
                    status: false,
                    from: "",
                },
                editPlan: {
                    status: false,
                    from: "",
                    planName: "",
                },
            }
        }
        case types.SET_DEFAULT_PLAN_SUCCESS: {
            return {
                ...state,
                defaultPlan: action.payload,
            }
        }
        case types.DELETE_PLAN_SUCCESS: {
            return {
                ...state,
                deletePlan: action.payload,
            }
        }
        case types.CLEAR_PLAN_DETAILS:
            return {
                ...state,
                name: "",
                description: "",
                status: [],
                addedChips: [],
            }
        default:
            return state
    }
}
